import { useState } from "react";
import classNames from "classnames";
import { BASE_URL } from "../utils/config";

export const checkImageLoad = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;

    img.onload = () => resolve(true);   // valid image
    img.onerror = () => resolve(false); // broken image
  });
};

 export const isValidUrl = (urlString) => {
    try {
      new URL(urlString);
      return true;
    } catch (_) {
      return false;
    }
  };

export const Avatar = ({ name, image, size = 32 }) => {
  const [imgError, setImgError] = useState(false);

  // initials
  const initials = name
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()

  const colors = [
    "bg-red-200 text-red-800",
    "bg-green-200 text-green-800",
    "bg-blue-200 text-blue-800",
    "bg-purple-200 text-purple-800",
    "bg-yellow-200 text-yellow-800",
  ];

  const color = colors[name?.length % colors.length];
  const url = image
    ? isValidUrl(image)
      ? image
      : `${BASE_URL}${image}`
    : null;

  // If we have a valid image AND no error → show image
  if (url && !imgError) {
    return (
      <img
        src={url}
        alt={name}
        className="rounded-full object-cover"
        style={{ width: size, height: size }}
        onError={() => setImgError(true)}
      />
    );
  }

  // Otherwise → show initials avatar
  return (
    <div
      className={classNames(
        "rounded-full flex items-center justify-center font-bold",
        color
      )}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.35,
      }}
    >
      {initials}
    </div>
  );
};

export const formatCreatedAt = (dateString) => {
  if (!dateString) return "--";

  const date = new Date(dateString);

  const weekday = date.toLocaleString("en-US", { weekday: "short" });
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${weekday},${day} ${month} ${year}`;
};

export const formatDateTime = (dateString)=> {
  if (!dateString) return "";
  const date = new Date(dateString);

  const options = {
    weekday: "short",   // Fri
    day: "2-digit",     // 09
    month: "short",     // Oct
    hour: "2-digit",    // 12
    minute: "2-digit",  // 00
    hour12: true        // AM/PM
  };  

  // Format with Intl.DateTimeFormat
  const formatted = new Intl.DateTimeFormat("en-US", options).format(date);

  // Convert "Fri, Oct 09, 12:00 PM" → "Fri, 09 Oct, 12:00 PM"
  const [weekday, month, day, time, meridiem] = formatted
    .replace(/,/g, "")
    .split(" ");
   return `${weekday}, ${day} ${month}, ${time} ${meridiem}`;;
}